import type { ApiIdentity } from '$lib/api/types';
import { setCacheAuthority } from './authority-cache';

// $state.raw because ApiIdentity is an API response we only ever reassign
// wholesale (set on load, swap on preview, null on sign-out) — never mutate
// fields. Skips the deep-proxy overhead.
//
// Class pattern per Svelte's recommendation — preferred over module-level
// $state + getter pairs for cross-component reactive singletons.

class IdentityStore {
  value = $state.raw<ApiIdentity | null>(null);

  set(i: ApiIdentity | null): void {
    setCacheAuthority(i);
    this.value = i;
  }
}

export const identity = new IdentityStore();
